/* eslint-disable no-unused-vars */
// @flow
import * as React from 'react'
import tw from 'tailwind-styled-components'

const ErrorLabel = tw.span`
  font-medium
  items-center
  mt-1
  text-red-500
  text-xs
  tracking-wide
`

export default ErrorLabel
